import { SMS_EXPIRATION_TIME_MS } from '../constants';

const isSmsCodeValid = (smsSentAt, expirationTimeMs = SMS_EXPIRATION_TIME_MS) => {
  return !!smsSentAt && expirationTimeMs >= new Date().getTime() - new Date(smsSentAt).getTime();
};

export default isSmsCodeValid;
